import { render, staticRenderFns } from "./EventDelegation.vue?vue&type=template&id=3e2f9f58&scoped=true"
import script from "./EventDelegation.vue?vue&type=script&lang=js"
export * from "./EventDelegation.vue?vue&type=script&lang=js"
import style0 from "./EventDelegation.vue?vue&type=style&index=0&id=3e2f9f58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../2026-08-26/github-cli-gh-codex/work/jiangkv3/web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2f9f58",
  null
  
)

export default component.exports